import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=57a8883e&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=57a8883e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8883e",
  null
  
)

export default component.exports